module.exports = __webpack_public_path__ + "img/Message-1s-200px-light.046b21f7.svg";